import { RadioButtonSettings } from './types';
import { Theme } from '../../../themeBase';

const radioCommonSettings = {
  boxShadow: (props: Theme) => `inset ${props.boxShadows.input}`,
  width: 2,
  minWidth: 2,
  height: 2,
};

const dotCommonSettings = {
  width: 0,
  height: 0,
};

const labelCommonSettings = {
  fontFamily: 'secondary',
  fontSize: 1,
  lineHeight: 1,
  fontWeight: 2,
  gap: 2,

  '&:focus-visible': {
    outlineColor: 'primary.light',
    outlineStyle: 'solid',
    outlineWidth: '2px',
  },
};

export const radioButtonSettings: RadioButtonSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        'selected-active': {
          borderColor: 'success.main',
          borderWidth: '2px',
          borderStyle: 'solid',
          cursor: 'pointer',
          ...radioCommonSettings,
          '&:before': {
            visibility: 'visible',
            backgroundColor: 'success.main',
            ...dotCommonSettings,
          },
        },
        'selected-disabled': {
          borderColor: 'success.light',
          borderWidth: '2px',
          borderStyle: 'solid',
          ...radioCommonSettings,
          '&:before': {
            visibility: 'visible',
            backgroundColor: 'success.light',
            ...dotCommonSettings,
          },
        },
        'unselected-active': {
          borderColor: 'gray.main',
          borderWidth: '1px',
          borderStyle: 'solid',
          backgroundColor: 'white.main',
          cursor: 'pointer',
          '&:before': {
            visibility: 'hidden',
            ...dotCommonSettings,
          },
          ...radioCommonSettings,
        },
        'unselected-disabled': {
          borderColor: 'gray.main',
          borderWidth: '1px',
          borderStyle: 'solid',
          backgroundColor: 'white.dark',
          '&:before': {
            visibility: 'hidden',
            ...dotCommonSettings,
          },
          ...radioCommonSettings,
        },
      },
    },
    labelVariant: {
      prop: 'labelVariant',
      variants: {
        active: {
          ...labelCommonSettings,
          color: 'primary.extraDark',
          cursor: 'pointer',
        },
        disabled: {
          ...labelCommonSettings,
          color: 'gray.main',
        },
      },
    },
  },
};
